import { TEntityOverride } from 'src/types'

const override: TEntityOverride = {
  titleField: 'name',
  global: {
    properties: {
      cameraId: {
        displayedName: 'Camera',
        reference: {
          target: 'Camera',
          targetLabelKeyPath: 'name',
        },
      },
      vms: {
        reference: {
          target: 'Vms',
          targetLabelKeyPath: 'name',
        },
      },
      groups: {
        type: 'groups',
      },
      fileId: {
        hidden: true,
      },
    },
  },
  list: {
    properties: {
      overlayImage: {
        hidden: true,
      },
    },
  },
}

export default override
